import styled from 'styled-components';

export const ButtonWrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-end;
`;
